var exports = {
  "zr": "xa15a2ab7--bd22f9--root",
  "Sl": "xa15a2ab7--bd22f9--image",
  "WD": "xa15a2ab7--bd22f9--labels",
  "Pf": "xa15a2ab7--bd22f9--label",
  "hb": "xa15a2ab7--bd22f9--label-count",
};

module.exports = exports;
